import { render, staticRenderFns } from "./jgOutstockSel.vue?vue&type=template&id=019525ba&scoped=true&"
import script from "./jgOutstockSel.vue?vue&type=script&lang=js&"
export * from "./jgOutstockSel.vue?vue&type=script&lang=js&"
import style0 from "./jgOutstockSel.vue?vue&type=style&index=0&id=019525ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019525ba",
  null
  
)

export default component.exports